<template>
	<div id="Thankyou3">
		<div class="section">
			<div class="library-info">
				<h2 class="section-title" id="up">Scarica subito l'ebook gratuito!</h2>
				<h1 align="center"><a href="#form_tre"><img id="tre" style="max-width:10em;" src='@/assets/ginocchia.jpg' class="left" @click="attiva_tre()"></a></h1>

				<div id="form_tre" class="container-desktop pad-l ebook1">
					<div class="contact-form">
						<form class="pad-l" @submit.prevent="submitEbookKnee">
							<div class="title">Scarica subito l'eBook gratuito - Ginocchia a prova di runner</div>

							<div class="input-grid">
								<div class="form-input">
									<label>Nome</label>
										<input type="name" v-model="formData.name" name="name" placeholder="Nome" required/>
									<label>Cognome</label>
										<input type="name" v-model="formData.surname" name="surname" placeholder="Cognome" required/>
									<label>Email</label>
										<input type="email" v-model="formData.email" name="email" placeholder="Email" required/>
								</div>
								<div class="submit">
									<button>SCARICA SUBITO!</button>
								</div>
							</div>
						</form>
					</div>
				</div>


			</div>
		</div>

		<!--<div class="barrasep" style="width: 100%; height: 3em; background-color: #ffe010;"></div>
			
		<About/>-->
	</div>

</template>
<script>
import api from '@/api'
import VideoCard from '@/components/library/VideoCard'
import Card from '@/components/home/Card'
import About from '@/components/home/About'

export default {
	name: 'grazie',

	components: {
		VideoCard,
		Card,
		About
	},

	data() {

		return {
			/// Authenticated user
			me: null,

			/// Loaded videos
			videos: [],

			/// Request form
			formData: {
				firstName: '',
				lastName: '',
				email: '',
				message: '',
				service: 'prova gratuita'
			},

			/// Request form2 
			formData2: {
				firstName: '',
				lastName: '',
				email: '',
				message: '',
				service: 'EOT'
			},

			/// Video categories
			categories: [
				{
					workout: 'workout',
					'video-scheda': 'video-scheda',
					core: 'core/addome',
					mobilità: 'mobilità',
					cardio: 'cardio',
					'total body': 'total body',
					'upper body': 'upper body',
					gambe: 'gambe'
				},
				{
					base: 'base',
					intermedio: 'intermedio',
					avanzato: 'avanzato',
					women: 'women'
				},
				{
					manubri: 'manubri',
					kettlebell: 'kettlebell',
					trx: 'trx',
					elastici: 'elastici',
					slider: 'slider'
				}
			],

			/// Active tags
			activeTags: []
		}
	},

	created(){

    },

	computed: {
		/**
		 * 
		 */
		filteredVideos2() {

			return this.activeTags.length === 0 ? [
		{'id': 'DSr4ze9Yvas', 'title': 'Workout functional total body livello Base 1', 'tags': ['workout', 'base', 'total body'], 'description': ''},
		{'id': 'ddK-8RxInNE', 'title': 'Cardio & Core 1', 'tags': ['cardio', 'core', 'video-scheda'], 'description': ''},
		{'id': 'um-wwpWr-J8', 'title': 'Workout TRX 2', 'tags': ['video-scheda', 'total body', 'trx'], 'description': ''},
		] : this.videos.filter((video) => this.activeTags.some((tag) => video.tags.findIndex((t) => t == tag) !== -1))
		},

		filteredVideos() {

			return this.activeTags.length === 0 ? [
		{'id': 'QHpwcsDTmw8', 'title': 'Cardio - Tabata 4', 'tags': ['cardio'], 'description': ''},
		{'id': 'Sz8qE_iv0H0', 'title': 'Workout functional total body intermedio 6', 'tags': ['workout', 'total body', 'kettlebell', 'manubri', 'intermedio'], 'description': ''},
		{'id': 'iJQXPAzqXr4', 'title': 'Cardio & Core 4', 'tags': ['cardio', 'core', 'video-scheda'], 'description': ''},
		] : this.videos.filter((video) => this.activeTags.some((tag) => video.tags.findIndex((t) => t == tag) !== -1))
		},

		/**
		 *
		 */
		videoTags() {

			return new Set(this.filteredVideos.reduce((tags, video) => [ ...tags, ...video.tags ], []))
		},

		/**
		 *
		 */
		videosByTag() {
			
			let videos = {
				general: []
			}

			for (let video of this.filteredVideos)
			{
				if (video.tags.length === 0)
				{
					videos.general.push(video)
				}
				else
				{
					for (let tag of video.tags)
					{
						videos[tag] = videos[tag] || []
						videos[tag].push(video)
					}
				}
			}

			return videos

			if (this.$route.query.tags)
			{
				const tags = this.$route.query.tags.split(',')
				return this.videos.filter((video) => {
					
					for (let tagid of video.tags)
					{
						const name = this.tags[tagid].name
						if (tags.indexOf(name) !== -1) return true
					}

					return false;
				})
			}
			else return this.videos
		}
	},

	methods: {
		/**
		 * 
		 */
		provagratuita2(){

			var formprova = document.getElementById("formprovagratuita2");
			var bottone = document.getElementById("provagratuita2");

			if(formprova.style.display == "none")
			{
				formprova.style.display = "block";
				bottone.innerHTML = "X";
				
			}
			else if(formprova.style.display == "block")
			{
				formprova.style.display = "none";
				bottone.innerHTML = "Richiedi la PROVA GRATUITA";
			}
		},
		provagratuita(){

			var formprova = document.getElementById("formprovagratuita");
			var bottone = document.getElementById("provagratuita");

			if(formprova.style.display == "none")
			{
				formprova.style.display = "block";
				bottone.innerHTML = "X";
				
			}
			else if(formprova.style.display == "block")
			{
				formprova.style.display = "none";
				bottone.innerHTML = "Richiedi la PROVA GRATUITA";
			}
		},

		async submitEbookKnee() {
			
			try
			{
				await api.make('POST', /* endpoint */'/public/ebook_knee', /* data */{
					email: this.formData.email,
					name: this.formData.name,
					surname: this.formData.surname
				}, /* bJson */true)

				/*notif.done('Grazie! La tua richiesta è stata inoltrata')*/
				this.$router.push('grazie-ginocchia')
			}
			catch (e)
			{
				/*console.error('console error')
				notif.error('notif error')*/

  				/*document.getElementById("messaggio").style.display = "block";*/

				/*this.$router.push('thankyou')*/

			}
		},

		/**
		 * 
		 */
		
	},

	mounted() {

		window.scrollTo(0, 0)
	},

}

/* Event snippet for Prenotazione prova gratuita conversion page google ads*/

gtag('event', 'conversion', {'send_to': 'AW-694720375/8u0JCMykmr4CEPeuossC'});

</script>

<style lang="stylus" scoped>
#Thankyou

.form-input select
	max-width 100%

	.banner
		margin-top 0 !important

		.ratio-box
			width 100%

			position relative

			padding-bottom 30%

			background-color @darker

			.presentation-video
				width 100%
				height 100%

				display block

				position absolute
				z-index 1
	
	.contact-form
		margin 1.5em
		padding 2em

		background-color dark

		.title
			font-size 1.2em
		
		.input-grid
			margin-top 1.5em

			.form-input
				margin 0.5em 0

				box-sizing border-box
				
				label
					display block

					margin-bottom 0.4em

					font-size 0.8em

				input
					width 100%

					display block
				
					padding 0.4em 0.6em
					border none
					border-bottom 2px solid transparent
					box-sizing border-box

					background-color darkish
					color light

					font-size 1.2em

					transition 0.2s ease

					&:focus
						outline none
						border-bottom 2px solid primary
				
				select
					padding 0.4em 0.6em
					border none
					border-bottom 2px solid transparent
					box-sizing border-box

					background-color darkish
					color light

					font-size 1.2em
				
				textarea
					width 100%

					display block

					padding 0.4em 0.6em
					border none
					border-bottom 2px solid transparent
					box-sizing border-box

					background-color darkish
					color light

					font-family fontSans
					font-size 1.1em

					transition 0.2s ease

					&:focus
						outline none
						border-bottom 2px solid primary
			
			.submit
				margin-top 4em

				button
					width 100%

					padding 0.6em
					border none

					background-color primary
					color dark

					font-family fontSans
					font-size 1.3em

					cursor pointer

					transition 0.2s ease

					&:focus
						outline none
	
	.category
		max-width 1280px

		margin auto
		padding 1em

		h3
			padding 0.6em
			border-bottom 1px solid secondary

			font-size 1.5em
			text-transform capitalize

		.videos
			max-width 1280px

			display grid
			grid-template-columns repeat(3, 1fr)
			grid-gap 1em

			margin auto

			@media screen and (max-width: 767px)
				grid-template-columns auto

.bar
	display grid
	grid-template-columns repeat(2, 1fr)
	grid-gap 1em

	padding 1em

	@media (max-width: unit(767, px))
		grid-template-columns auto

.filtro
	width 100%
	background #101418
	height 3em
	margin-bottom 3em

	@media (max-width: unit(850, px))
		height 100%
		padding-bottom 0.7em

.catcont
	width 850px
	margin 0 auto
	position relative
	display flex
	padding-top 0.6em

	@media (max-width: unit(850, px))
		width 100%
		display grid

.categoria
	text-transform uppercase
	font-size 1.1em
	font-weight bold
	margin 0 auto

.link
	text-decoration none 
	color #dcdcdc
	transition 0.2s ease
	cursor pointer

	padding 0.2em

	&.active
		border-radius 0.2em

		background-color primary
		color darkish

.link:hover
	color #ffe010

	@media (max-width: unit(767, px))
		color darkish

.up
	position fixed
	bottom 0
	left 0
	margin-left 1em
	margin-bottom 1em
	width 2.5em
	height 2.5em
	border-radius 2.5em
	background #ffe010
	z-index 9999

.progselect
	max-width 570px
	margin 0 auto
	text-align center

	.progworkout
		max-width 490px
		margin 0 auto
		p
			text-align left
			font-size 1.2 em
			margin-left 0.7em

.divprogramma
	display grid
	grid-template-columns repeat(3, 1fr)
	grid-gap 1em

	@media (max-width: unit(560, px))
		grid-template-columns auto

.programma
	padding 0.4em 0.6em
	border none
	border-bottom 2px solid transparent
	box-sizing border-box
	background-color darkish
	color light
	font-size 1.2em

.divprova
	max-width 100%
	padding 2em
	text-align center

.provagratuita
	max-width 500px

	padding 0.6em
	border none

	background-color primary
	color dark

	font-family fontSans
	font-size 1.6em

	cursor pointer

	transition 0.2s ease

	&:focus
		outline none

.presdesc
	list-style-type none

	li:before
		content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
		color: #ffe010; /* Change the color */
		font-weight: bold; /* If you want it to be bold */
		display: inline-block; /* Needed to add space between the bullet and the text */
		width: 1em; /* Also needed for space (tweak if needed) */
		margin-left: -1em; /* Also needed for space (tweak if needed) */

.divpres
	text-align center

	img
		display block
		margin 0 auto

.divbox
	display grid
	grid-template-columns auto
	grid-gap 1em

	@media (max-width: unit(767, px))
		grid-template-columns auto
	
	ul
		text-transform uppercase
		font-weight bold

.divul
	text-align left
	margin 0 auto

.contact-form
		grid-column 1/5

		margin 1.5em
		padding 2em

		background-color dark

		.title
			font-size 1.2em
		
		.input-grid
			margin-top 1.5em

			.form-input
				margin 0.5em 0

				box-sizing border-box
				
				label
					display block

					margin-bottom 0.4em

					font-size 0.8em

				input
					width 100%

					display block
				
					padding 0.4em 0.6em
					border none
					border-bottom 2px solid transparent
					box-sizing border-box

					background-color darkish
					color light

					font-size 1.2em

					transition 0.2s ease

					&:focus
						outline none
						border-bottom 2px solid primary
			
			.submit
				margin-top 4em

				button
					width 100%

					padding 0.6em
					border none

					background-color primary
					color dark

					font-family fontSans
					font-size 1.3em

					cursor pointer

					transition 0.2s ease

					&:focus
						outline none

</style>
